/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const findWorkFlows = /* GraphQL */ `
  query FindWorkFlows {
    findWorkFlows {
      items {
        container
        bol
        status
      }
    }
  }
`;

export const listExceptions = /* GraphQL */ `
  query ListExceptions(
    $limit: Int = 25,
    $offset: Int = 0,
    $filter: ExceptionFilterInput,
    $orderBy: ExceptionOrderByInput,
    $customsTerritories: [String!]!
  ) {
    exception {
      list(
        limit: $limit,
        offset: $offset,
        filter: $filter,
        orderBy: $orderBy,
        customsTerritories: $customsTerritories
      ) {
        items {
          id
          description
          status
          priority
          targetResolutionDate
          resolutionType
          creationDate
          consignment {
            id
            billOfLadingNbr
            modeOfTransport
            carrier
            originCountry
            dischargeCountry
            productDivision
          }
        }
        pageInfo {
          totalCount
          status
          message
        }
      }
    }
  }
`;

export const listEquipmentVehicles = /* GraphQL */ `
query ListEquipmentVehicles($limit: Int = 25, $offset: Int = 0, $filter: EquipmentVehicleFilterInput, $orderBy: EquipmentVehicleOrderByInput) {
  equipmentVehicle {
    list(limit: $limit, offset: $offset, filter: $filter, orderBy: $orderBy, customsTerritories: ["US", "EU"]) {
      items {
        id
        voyageNumber
        plannedDischargeDate
        modeOfTransport
        carrier
        originCountry
        dischargeCountry
        consignmentCount
        consignments {
          items {
            id
            billOfLadingNbr
          }
        }
      }
      pageInfo {
        totalCount
        status
        message
      }
    }
  }
}
`;

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    node(id: $id) {
      ... on User {
        id
        name
        email
        avatarUrl
        settings {
          selectedTerritories
          availableTerritories
        }
        openExceptions(limit: 10, offset: 0) {
          items {
            id
            description
            status
            priority
          }
          pageInfo {
            totalCount
            status
            message
          }
        }
      }
    }
  }
`;